import { Component } from 'react'
import styled from 'styled-components'
import { Tooltip } from 'react-tippy'

import { detectSafari } from '../../utils/functions'
import 'react-tippy/dist/tippy.css'
import { Desktop, Mobile } from '../../utils/media'

const Wrapper = styled.div({
  position: 'relative',
})

export default class NewFeatureTooltip extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showTooltip: detectSafari() ? false : props.show,
      offsetX: null,
      offsetY: null,
    }
  }

  componentDidUpdate(prevProps) {
    const { refs, index, show } = this.props
    if (
      detectSafari() &&
      prevProps.refs.length !== refs.length &&
      refs[index]?.current
    ) {
      this.setState({
        offsetX: refs[index]?.current.offsetWidth,
        offsetY: refs[index]?.current.offsetHeight,
        showTooltip: show,
      })
    }
    if (prevProps.show !== show) {
      this.setState({ showTooltip: show })
    }
  }

  render() {
    const { showTooltip, offsetY, offsetX } = this.state
    const { distance, content, children } = this.props

    if (!showTooltip) {
      return children
    }

    return (
      <Wrapper>
        <Desktop>
          <Tooltip
            open={showTooltip}
            position="left"
            theme="light"
            interactive
            arrow
            distance={detectSafari() ? 0 : -distance || 0}
            popperOptions={{
              modifiers: {
                shift: {
                  enabled: detectSafari(),
                  fn: (data) => {
                    data.arrowStyles = {
                      transform: `translateY(${-offsetY / 2}px)`,
                    }
                    return data
                  },
                },
                preventOverflow: {
                  enabled: false,
                },
                hide: {
                  enabled: false,
                },
                offset: {
                  enabled: detectSafari(),
                  offset: `0, ${-offsetX - distance || 0}`,
                },
                addZIndex: {
                  enabled: true,
                  order: 810,
                  fn: (data) => ({
                    ...data,
                    styles: {
                      ...data.styles,
                      zIndex: 119,
                    },
                  }),
                },
              },
            }}
            html={content}
          >
            {children}
          </Tooltip>
        </Desktop>
        <Mobile>{children}</Mobile>
      </Wrapper>
    )
  }
}
